export default __webpack_public_path__ + "static/media/bg.e6650845.jpg";